import React from "react";
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

const styles = theme => ({
  root: {
    backgroundColor: "white",
    padding: theme.spacing(2),
    borderRadius: 3
  }
});

class OSSMetricPod extends React.Component {
  static Metric = ({ children, classes = {} }) => {
    return (
      <Typography variant="h4" className={classes.metric}>
        {children}
      </Typography>
    );
  };

  static Label = ({ children, classes = {} }) => {
    return (
      <Typography variant="h6" className={classes.label}>
        {children}
      </Typography>
    );
  };

  render() {
    const { children, classes, border, inlineStyles } = this.props;

    return (
      <Paper
        className={classes.root}
        style={
          border
            ? Object.assign(
                {},
                {
                  border: "1px solid #dadada"
                },
                inlineStyles
              )
            : Object.assign({}, inlineStyles, { border: "none" })
        }
        elevation={0}
        square
      >
        {children}
      </Paper>
    );
  }
}

OSSMetricPod.propTypes = {
  children: PropTypes.node,
  border: PropTypes.bool,
  inlineStyles: PropTypes.object
};
OSSMetricPod.defaultProps = {
  children: "",
  border: true,
  inlineStyles: {}
};

export default withStyles(styles)(OSSMetricPod);
